import { FieldDefinitionType } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { DescriptionAttribute, Maybe } from 'graphql-api/gql-api-interfaces';
import { pipe } from 'rxjs';

type AttributesPriorityConfig = {
  [groupName: string]: string[];
};

export function mapDescriptionAttrsToPanelFields(
  product: {
    descriptionAttributes?: Maybe<DescriptionAttribute[]>;
  },
  attributesPriorityConfig: AttributesPriorityConfig = {},
) {
  if (!product) {
    return null;
  }

  const filteredAttributes = pipe(
    filterAttributesFromSameGroup(attributesPriorityConfig),
  )(product.descriptionAttributes ?? []);

  const fields = filteredAttributes.map((attribute) => ({
    name: `attributes.${attribute.key}`,
    label: attribute.displayName,
    type: FieldDefinitionType.text,
  }));

  return {
    properties: {
      id: 'product-details-panel',
      contentTypeId: 'attributes-panel',
    },
    fields,
  };
}

// Filter attributes from one config group and left only the one from group
function filterAttributesFromSameGroup(
  attributesPriorityConfig: AttributesPriorityConfig,
) {
  return (descriptionAttributes: DescriptionAttribute[]) =>
    descriptionAttributes.filter((attribute) => {
      const oneGroupAttributes: string[] =
        Object.values(attributesPriorityConfig).find((groupValues) => {
          return groupValues.indexOf(attribute.key) !== -1;
        }) ?? [];

      if (oneGroupAttributes.length === 0) return true;

      const priorityOrder = oneGroupAttributes.indexOf(attribute.key);
      // less array index means more priority
      if (priorityOrder === 0) return true;

      const morePrioritizedAttributes = oneGroupAttributes.slice(
        0,
        priorityOrder,
      );

      return !morePrioritizedAttributes.some((prioritizedAttribute) => {
        return descriptionAttributes?.some(
          ({ key }) => key === prioritizedAttribute,
        );
      });
    });
}
